export const setNullForUndefinedValue = (value: string | undefined | null) => (value === undefined || value === 'undefined') ? null : value;
